module.exports = __webpack_public_path__ + "images/questions/qa_bg_dot_cream_80c257acde1c931af6d3ca9da4ec57d9.png";